import { render, staticRenderFns } from "./template1.vue?vue&type=template&id=cf5125f8&scoped=true"
import script from "./template1.vue?vue&type=script&lang=js"
export * from "./template1.vue?vue&type=script&lang=js"
import style0 from "./template1.vue?vue&type=style&index=0&id=cf5125f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5125f8",
  null
  
)

export default component.exports